import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

const mobile = (styles: any) => css`
  ${({ theme }) => theme?.isWidget && styles};

  @media (max-width: 768px) {
    ${styles}
  }
`;

export const WeatherDayTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(16)};

  ${mobile(css`
    display: flex;
    align-items: center;
    gap: ${toRem(100)};
  `)}
`;

export const Title = styled.div`
  display: block;
  font-size: ${toRem(24)};
  font-weight: 700;
  line-height: ${toRem(36 / 24)};

  ${mobile(css`
    font-size: ${toRem(16)};
    line-height: ${toRem(24 / 16)};
  `)};
`;

export const WeatherDayArrowWrapper = styled.div`
  width:${toRem(24)};
  height: ${toRem(24)};

  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;

    path {
      fill: ${COLORS.FG.DEFAULT}
    }
  }
`;
